<template>
  <section class="grouped">
    <div class="header">
      <header>Gestor</header>
      <b-button
        v-if="hasAdminPermission"
        v-b-modal="'managers-selector'"
        class="float-right d-inline-block p-0"
        variant="outline"
      >
        <img :src="require('@/assets/icons/create-icon.svg')">
      </b-button>
    </div>
    <div v-if="project.managers.length == 0" class="elements">
      No hay nada añadido
    </div>
    <div v-else class="elements">
      <EmployeeBadge
        v-for="employee in project.managers" :key="employee.id"
        :employee="employee"
        :dismissible="hasAdminPermission"
        @remove="remove"
      />
    </div>
    <EmployeeSelectorModal
      id="managers-selector"
      subtitle="Selecciona las personas a añadir como gestores"
      :employeesToIgnore="project.nonManagers"
      :loadedMembers="project.managers"
      @confirmed="add"
      @onNewEmployee="onNewEmployee"
    />
  </section>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import EmployeeBadge from '@/components/Business/Project/Form/Employee/EmployeeBadge/EmployeeBadge.vue'
import EmployeeSelectorModal from '@/components/Business/Project/Form/Employee/EmployeeSelector/EmployeeSelectorModal.vue'

export default {
  name: 'ListManagers',
  components: {
    EmployeeBadge,
    EmployeeSelectorModal
  },
  props: {
    hasAdminPermission: {
      type: Boolean
    }
  },
  computed: {
    ...mapGetters({ project: 'project/current' })
  },
  methods: {
    ...mapMutations('project', ['setManagers', 'updateTeam']),
    add (managers) {
      this.setManagers(managers)
    },
    remove (id) {
      this.setManagers(this.project.managers.filter(manager => manager.id !== id))
      this.removeEmployeeFromTeams(id)
    },
    onNewEmployee (modalId) {
      this.$emit('onNewEmployee', modalId)
    },
    removeEmployeeFromTeams (id) {
      this.project.teams.forEach(team => {
        if (team.members.find(member => member.id === id)) {
          const members = team.members.filter(member => member.id !== id)
          this.updateTeam({ name: team.name, members: members })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import "listManagers";
</style>
